import { Component, CUSTOM_ELEMENTS_SCHEMA, Inject } from '@angular/core';

import { EventNotificationsServiceBase } from '@skylab-shared/business';
import { ImportProductsIdentification, LabeledEnumValue, LabeledEnumValueConverter } from '@skylab-shared/dataModel';
import { ToastDelay } from '@skylab-shared/ui';

import { EventNotificationsService, ImportRepository, ImportRepositoryBase } from '@skylab-angular-shared/business';
import { EnumTranslator, EnumTranslatorBase, L10n, L10nBase } from '@skylab-angular-shared/core';
import { ButtonComponent, DialogContentComponentIns, DialogHeaderComponentIns, DialogInsService, DialogState, FilepickerInsComponent, FocusByDirective, FormContainerComponent, PasswordComponentIns, SelectValueAccessorDirective, ToastService, TooltipDirective, IconComponent } from '@skylab-angular-shared/ui';

import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { ImportDialogBase, ImportViewModel } from '../import-dialog-base';

export interface ImportProductsViewModel extends ImportViewModel {
    identificationKind: ImportProductsIdentification;
    identificationKinds: LabeledEnumValue[];
    identificationKindValueConverter: LabeledEnumValueConverter<ImportProductsIdentification>;
}

@Component({
    selector: 'skl-import-products-dialog',
    templateUrl: './products-import-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [DialogContentComponentIns, DialogHeaderComponentIns, FormContainerComponent, FocusByDirective, FilepickerInsComponent, PasswordComponentIns, FormsModule, NgClass, TooltipDirective, SelectValueAccessorDirective, ButtonComponent, TranslatePipe, IconComponent]
})
export class ImportProductsDialogComponent extends ImportDialogBase<ImportProductsViewModel> {

    public constructor(
        @Inject(EnumTranslator) enumTranslator: EnumTranslatorBase,
        @Inject(ImportRepository) importRepository: ImportRepositoryBase,
        dialogService: DialogInsService,

        private readonly toastService: ToastService,
        @Inject(L10n) private readonly l10n: L10nBase,
        @Inject(EventNotificationsService) private readonly eventNotifications: EventNotificationsServiceBase,
    ) {
        super(enumTranslator, importRepository, dialogService);
    }

    protected override getInitialState(): ImportProductsViewModel {
        return {
            ...super.getInitialState(),
            identificationKinds: this.enumTranslator.getLabeledEnumValueArray(ImportProductsIdentification),
            identificationKind: ImportProductsIdentification.Symbol,
            identificationKindValueConverter: new LabeledEnumValueConverter(this.enumTranslator, ImportProductsIdentification)
        };
    }

    protected async postImportRequestAsync(data: FormData): Promise<any> {
        return await this.importRepository.importProductsAsync(data, {
            duplicates: this.viewModel.handleDuplicate
        });
    }

    protected onImportSuccess(response: any): boolean {
        const _T = this.l10n._T;

        this.toastService.showAsync({
            type: 'success',
            text: _T('scenes.dialogs.products-import.messages.success'),
            duration: ToastDelay.VeryLong,
        });
        this.eventNotifications.refreshInterval('imports');
        this.dialogService.close({ state: DialogState.Confirm });
        return true;
    }

    protected onImportError(reason: any): boolean {
        const _T = this.l10n._T;

        this.toastService.showAsync({
            type: 'error',
            text: _T('scenes.dialogs.products-import.messages.error'),
            duration: undefined,
        });

        this.dialogService.close({ state: DialogState.Cancel });

        return true;
    }
}
